import React, { useEffect } from "react";
import { Icon } from "./CreateIcons.jsx"
import ThurentEventForm from "../redesign/components/ThurentEventForm";
import { CssBaseline, Stack, IconButton } from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import "./Contactuspage_module.css";
import Services from "../ProviderServices.json";
import ButtonMailto from "./ButtonMailto";
import CreateEventCTA from "./EventServices/CreateEventCTA";
import { homePagePath } from "../constant";
import config from "../config";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";
import { formatRegionAddress, getRegionContactInfo } from "../util/contactRegion";

export const Contactuspage = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const role = useSelector((state) => state.auth.role);

  const contact = getRegionContactInfo();
  const activeContactInfo = contact || config.contactInfo?.india || config.contactInfo?.usa;
  const phoneNumber = activeContactInfo?.phone || "";
  const emailAddress = activeContactInfo?.email || "";
  const contactAddress = activeContactInfo?.address || "";
  const contactName = activeContactInfo?.name || "";
  const contactTitle = activeContactInfo?.title || "";

  const backtoHome = () => {
    isLoggedIn
      ? role === "customer"
        ? navigate("/dashboard")
        : navigate("/service-provider/dashboard")
      : navigate(homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const hasContactDetails = !!(phoneNumber || emailAddress || contactAddress);

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />
      <div className={`main-container-contactus ${!isLoggedIn && "no-auth"}`}>
        <div className="frontend-container">
          {(!isLoggedIn || (isLoggedIn && role === "customer")) && (
            <div className="header-container-contact">

              <div className="event-service-list-contact sidebar">
                {Services.length > 0 &&
                  Services.map((item) => (
                    <Link
                      key={item.id}
                      className="event-service-list-link sidebar"
                      to={`/service/${item.slug}`}
                    >
                      <div className="event-service-button-data">
                        <div className="event-services-buttons-icons">
                          <Icon id={item.id} />
                          {/* <img
                        style={{
                          display: "block",
                          width: "50px",
                        }}
                        src={`${process.env.PUBLIC_URL}/assets/images/${item.id}.png`}
                        alt={item.serviceName}
                      /> */}
                          <div>
                            <span>
                              {item.serviceCardName}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
              </div>


            </div>
          )}

          <div className="event-form-inner-contact">
            <div
              className={`event-form-body ${isLoggedIn && role === "provider" ? "alter full" : "list"
                }`}
            >
              <div className="event-form-body-inner">
                <div className="event-form-content event-service-content">
                  <div className="section contact">
                    <h3 className="font-legal" style={{ color: "#26B8E3" }}>
                      Contact Details
                    </h3>
                    {hasContactDetails && (
                      <>
                        <div className="contact-details-panel">
                          {contactName && (
                            <div className="contact-detail-row">
                              <i className="pi pi-user contact-detail-icon"></i>
                              <div className="contact-detail-copy">
                                <span className="contact-detail-label">Name</span>
                                <span className="contact-detail-value">{contactName}</span>
                              </div>
                            </div>
                          )}
                          {contactTitle && (
                            <div className="contact-detail-row">
                              <i className="pi pi-briefcase contact-detail-icon"></i>
                              <div className="contact-detail-copy">
                                <span className="contact-detail-label">Role</span>
                                <span className="contact-detail-value">{contactTitle}</span>
                              </div>
                            </div>
                          )}
                          {phoneNumber && (
                            <div className="contact-detail-row">
                              <i className="pi pi-phone contact-detail-icon"></i>
                              <div className="contact-detail-copy">
                                <span className="contact-detail-label">Phone</span>
                                <span className="contact-detail-value">{phoneNumber}</span>
                              </div>
                            </div>
                          )}
                          {emailAddress && (
                            <div className="contact-detail-row">
                              <i className="pi pi-envelope contact-detail-icon"></i>
                              <div className="contact-detail-copy">
                                <span className="contact-detail-label">Email</span>
                                <span className="contact-detail-value">{emailAddress}</span>
                              </div>
                            </div>
                          )}
                          {contactAddress && (
                            <div className="contact-detail-row contact-detail-row--address">
                              <i className="pi pi-map-marker contact-detail-icon"></i>
                              <div className="contact-detail-copy">
                                <span className="contact-detail-label">Address</span>
                                <span className="contact-detail-value address-value">
                                  {contactAddress
                                    .split("\n")
                                    .map((line, index) => (
                                      <React.Fragment key={index}>
                                        {line}
                                        {index < contactAddress.split("\n").length - 1 && <br />}
                                      </React.Fragment>
                                    ))}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>

                        <h4
                          style={{ marginBottom: "15px" }}
                          className="font-legal"
                        >
                          SEND US A MESSAGE - WE WILL CONTACT YOU
                        </h4>
                        <div className="contact-email-cta">
                          <ButtonMailto
                            label="Send E-Mail"
                            mailto={emailAddress}
                            subject="General enquiry"
                            body={`Hi,\n\n`}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="create-event">
                <ThurentEventForm />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ConfirmDialog />
    </div>
  );
};
export default Contactuspage;
